var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-navigation"},[_c('aside',{staticClass:"sidebar"},[_c('div',{staticClass:"sidebar-top"},[_vm._t("side-top")],2),_c('div',{staticClass:"sidebar-bottom"},[_vm._t("side-bottom")],2)]),_c('main',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }